export default __webpack_public_path__ + "static/controllers-af92c30e59a30a5312f0ee5fbbe70224.png";